import { Component, OnInit,ViewChild,Input} from '@angular/core';
import { Router } from '@angular/router';
import { AddMedicalCarePlanComponent } from './add-medical-care-plan/add-medical-care-plan.component';
import { MasterService } from 'src/app/masters/master.service';
import { LoaderService } from 'src/app/common/loader.service';
import { MedicalFileService } from './medical.file.service';

@Component({
  selector: 'app-medical-care-plan',
  templateUrl: './medical-care-plan.component.html',
  styleUrls: ['./medical-care-plan.component.scss']
})
export class MedicalCarePlanComponent implements OnInit {
  addMedCarePlan;
  toggleColumn=true;
  newCarePlan: AddMedicalCarePlanComponent;
  carePlans=[];
  carePlanTypes=[];
  @Input() medFileId;
  @ViewChild(AddMedicalCarePlanComponent, { static: true }) set Content(newCarePlanRef) {
    this.newCarePlan = newCarePlanRef;
  }
  constructor(public router: Router,private medicalFileService:MedicalFileService, private masterService:MasterService,private loaderService:LoaderService) { }

  ngOnInit() {
    this.medicalFileService.getCarePlanTypes().subscribe(response => {
      if (response['code'] == 'S0000') {
        this.carePlanTypes = response['result'];

        this.medicalFileService.getCarePlans(this.medFileId).subscribe(response => {
          if (response['code'] == 'S0000') {
            this.carePlans = response['result'];
            for(let plan of this.carePlans){
              if(plan.catypId){
                plan["typeDescription"]=this.carePlanTypes.filter(type => type && type.catypId===plan.catypId)[0].catypDescEn;
              }
             
            }
          }
        });
      }
    });
    
  }
  addCarePlan() {
    this.newCarePlan.addCarePlanTitle = true;
    this.newCarePlan.editCarePlanTitle = false;
    this.router.navigate(['addmedcareplan']);
  }
  hideRightDiv() {
    this.addMedCarePlan = false;
    this.toggleColumn = true;
  }
  onRowClicked(event: any) {
    this.addMedCarePlan= true;
    this.toggleColumn = false;
    this.newCarePlan.addCarePlanTitle = false;
    this.newCarePlan.editCarePlanTitle = true;
     this.loadCarePlan(event);
   }
   loadCarePlan(event){
    this.loaderService.display(true);
    this.medicalFileService.getCarePlanTypesById(event.data.medcaId).subscribe(response => {
      this.loaderService.display(false);
      if (response['code'] == 'S0000') {
        let result = response['result'][0];
        this.newCarePlan.careplanForm.patchValue({
          medcaId:result["medcaId"],
          medcaVaPathology:result["medcaVaPathology"],
          medcaVaOrgan:result["medcaVaOrgan"],
          medcaVaProcedure:result["medcaVaProcedure"],
          medcaVaName:result["medcaVaName"],
          medcaVaTotalCost:result["medcaVaTotalCost"],
          catypId:result["catypId"],
          pctypId:result["pctypId"],
          medcaVaProblem:result["medcaVaProblem"],
          medcaVaAssessment:result["medcaVaAssessment"],
          medcaVaDifferentialDiagnoses:result["medcaVaDifferentialDiagnoses"],
          medcaVaEducation:result["medcaVaEducation"],
          medcaNuTotalDuration:result["medcaNuTotalDuration"],
          statuCode:result["statuCode"],
          medcaVaComment:result["medcaVaComment"],
          medfiId:result["medfiId"],
          staRecCode: result["staRecCode"] ==='A' ? true : false
        });
      }
    },
    error => {
      this.loaderService.display(false);
    })

   }
}
